// extracted by mini-css-extract-plugin
export var cardIcon = "_a7-5";
export var cardIconUnframed = "_a7-9";
export var checkboxCard = "_a7-0";
export var checkboxCardSelected = "_a7-4";
export var disabled = "_a7-2";
export var interactive = "_a7-1";
export var outerBorder = "_a7-3";
export var spacerMedium = "_a7-8";
export var spacerSmall = "_a7-7";
export var spacerXsmall = "_a7-6";